<template>
  <v-container class="pa-6">
    <v-row justify="center">
      <v-col cols="12">
        <div class="pageTitle" style="margin-bottom: 24px;">
          Profile
        </div>
      </v-col>
      <v-col cols="12">
        <v-row no-gutters>
          <v-img class="avatar" :src="avatarSrc" width="190" :aspect-ratio="1">
            <div class="avatarEditOverlay" @click="$refs.avatarInput.click()">
              <div class="avatarEditText" style="text-align: center">
                <div>
                  <v-btn class="ma-0 pa-0 avatarEditText" color="white" text>
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <div>
                    Change
                  </div>
                  <div>
                    Profile Picture
                  </div>
                </div>
              </div>
            </div>
          </v-img>
          <input
            ref="avatarInput"
            style="display: none"
            type="file"
            accept="image/*"
            @change="onAvatarSelected"
          />
        </v-row>
      </v-col>
      <v-col cols="12">
        <div class="textFieldLabel">
          Username <span class="required">*</span>
        </div>
        <v-text-field
          v-model="profile.handle"
          outlined
          hide-details
          hint="Enter Username"
          style="background: #fff; margin-bottom: 24px;"
        />
        <v-btn
          class="yellowButton"
          depressed
          block
          color="#000"
          height="52px"
          @click="saveProfile"
        >
          Save
          <v-icon style="margin-left: 16px; width: 20px; height: 20px;">
            mdi-arrow-right
          </v-icon>
        </v-btn>

        <div
          class="divider"
          style="margin-top: 40px; margin-bottom: 40px; border: 0.5px solid #aaa;"
        />

        <div class="textFieldLabel">
          Email
        </div>
        <v-text-field
          v-model="email"
          outlined
          hide-details
          disabled
          style="background: #eee; margin-bottom: 24px;"
        />

        <div class="textFieldLabel">
          Golden Moments ID
        </div>

        <v-text-field
          v-model="user.user.uid"
          outlined
          hide-details
          disabled
          style="background: #eee; margin-bottom: 24px;"
        />
      </v-col>

      <v-col cols="12">
        <div class="pageTitle" style="margin-bottom: 24px;">
          Security
        </div>

        <div class="textFieldLabel">
          New Password <span class="required">*</span>
        </div>
        <v-text-field
          v-model="password"
          outlined
          hide-details
          type="password"
          style="background: #fff; margin-bottom: 24px;"
        />
        <div class="textFieldLabel">
          Confirm New Password <span class="required">*</span>
        </div>
        <v-text-field
          v-model="passwordConfirm"
          outlined
          hide-details
          type="password"
          style="background: #fff; margin-bottom: 24px;"
        />
        <v-btn
          class="yellowButton"
          block
          depressed
          color="#000"
          height="52px"
          :disabled="!password || password !== passwordConfirm"
          @click="updatePassword"
        >
          Change Password
          <v-icon style="margin-left: 16px; width: 20px; height: 20px;">
            mdi-arrow-right
          </v-icon>
        </v-btn>

        <v-col cols="12" style="height: 60px;" />

        <v-btn
          class="saveButton"
          depressed
          block
          color="#000"
          height="52px"
          @click="logOut"
        >
          Sign Out
        </v-btn>
      </v-col>
    </v-row>
    <v-snackbar v-model="confirmDialog" bottom :timeout="3000">
      {{ confirmMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import AuthenticationManager from '@/controllers/AuthenticationManager';
  import { signOut, updatePassword } from 'firebase/auth';
  import Firebase from '@/lib/firebase';
  import ImageUploadManager from '@/lib/ImageUploadManager.js';

  export default {
    components: {},

    props: ['authenticated'],

    data: () => {
      return {
        avatar: null,
        avatarFile: null,
        profile: {},
        password: null,
        passwordConfirm: null,
        email: null,
        confirmMessage: false,
        confirmDialog: false,
      };
    },

    computed: {
      ...mapState({
        user: (state) => state.user,
      }),
      avatarSrc() {
        if (this.avatar) {
          return this.avatar;
        }
        if (this.profile && this.profile.avatarUrl) {
          return this.profile.avatarUrl;
        }
        return '';
      },
    },

    watch: {
      authenticated: {
        handler(val) {
          if (val) {
            this.email = Firebase.auth.currentUser.email;
          }
        },
        immediate: true,
      },
      user: {
        handler(val) {
          if (val) {
            this.profile = JSON.parse(JSON.stringify(val.user));
          } else {
            this.profile = {};
          }
        },
        immediate: true,
      },
    },

    mounted: function() {},

    methods: {
      ...mapActions({ setUser: 'setUser' }),
      saveProfile: async function() {
        if (this.avatarFile) {
          const { imageUrl } = await ImageUploadManager.uploadAvatar(
            this.avatarFile
          );
          this.profile.avatarUrl = imageUrl;
        }
        const user = await AuthenticationManager.updateProfile(this.profile);
        this.setUser(user);
        this.confirmMessage = 'Profile has been updated.';
        this.confirmDialog = true;
      },
      logOut: async function() {
        try {
          await signOut(Firebase.auth);
          this.setUser(null);
          this.$router.replace('/');
        } catch (error) {
          console.log(error);
        }
      },
      onAvatarSelected: async function(event) {
        var files = event.target.files;
        this.avatarFile = files[0];
        this.avatar = URL.createObjectURL(files[0]);
        this.saveProfile();
      },

      async updatePassword() {
        try {
          const user = Firebase.auth.currentUser;
          await updatePassword(user, this.password);
          this.confirmMessage = 'Password has been updated.';
          this.confirmDialog = true;
        } catch (error) {
          this.$emit('handleError', error);
        }
      },
    },
  };
</script>

<style scoped>
  .saveButton {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    letter-spacing: 0.003em !important;

    width: 177px !important;
    height: 56px !important;
    border-radius: 28px !important;

    background: #000000;
  }

  .avatar {
    box-sizing: border-box;

    max-width: 190px;
    height: 190px;

    /* Colour System 2/Shade/shade-50 */

    background: #ebebeb;
    mix-blend-mode: normal;
    /* Colour System 2/Shade/shade-100 */

    border: 3px solid #c0c0c0;
    border-radius: 95px;
  }

  .avatarEditOverlay {
    background: #ebebeb20;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .avatarEditText {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 20px !important;

    letter-spacing: 0.003em !important;

    color: #a1a1a1 !important;
  }
</style>
